import React from 'react';

export default function OverviewDivider() {
  return (
    <div className="hidden sm:block">
      <svg
        preserveAspectRatio="none"
        width="50"
        height="100%"
        viewBox="0 0 50 148"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="47" height="148" fill="white" />
        <path
          d="M0.117315 0C3.05086 0 5.67324 1.82917 6.6865 4.58218L29.2721 65.9469C30.7125 69.8604 30.7494 74.1528 29.3763 78.0905L6.63718 143.305C5.65682 146.116 2.97762 148 0 148V148V0H0.117315Z"
          fill="#F5F6F4"
        />
        <path
          d="M0.117315 0C3.05086 0 5.67324 1.82917 6.6865 4.58218L29.2721 65.9469C30.7125 69.8604 30.7494 74.1528 29.3763 78.0905L6.63718 143.305C5.65682 146.116 2.97762 148 0 148V148V0H0.117315Z"
          fill="#F5F6F4"
        />
        <path
          d="M20.5014 4.04412C19.7738 2.08438 21.2234 0 23.3138 0H50V148H24.9628C22.9109 148 21.4645 145.986 22.12 144.042L44.0475 78.9907C45.3647 75.0832 45.3003 70.842 43.8651 66.9763L20.5014 4.04412Z"
          fill="#EFF8F3"
        />
      </svg>
    </div>
  );
}
